import { CSVProfile, CSVTranformationProfile } from '../../types'
import { BaseVisualization } from '../base/base-visualization-component'

export class TableDataChartComponent extends BaseVisualization {
 static config = {
  selector: 'afTable',
  controller: TableDataChartComponent,
  template: `
            <div ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationData) && !$ctrl.isRestricted" class="top__twitter" >
                <mw-table>
                        <md-table-container>
                            <table class="mw-table--actions-visible" md-table>
                                <thead>
                                    <tr class="af__table__header">
                                        <th
                                            ng-repeat="header in $ctrl.visualizationOptions"
                                            ng-class="{'af__table__author': $first, 'af__table__numbers': !$first}"
                                            class="div-table-col">
                                                <span translate>{{header}}</span>
                                            </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="af__table__body" md-row ng-repeat="dataRow in $ctrl.visualizationData">

                                        <td class="mw-table__greedy-column af__table__author" md-truncate>
                                            <div class="af__table__count">{{ $index+$ctrl.pagination.itemIndex }} {{ $ctrl.treatments.EXPLORE_ANALYTICS_UPDATE }}</div>
                                            {{ $ctrl.treatments.EXPLORE_ANALYTICS_UPDATE }}

                                            <div class="af__table__icon">
                                                <div  ng-if="dataRow.imageSource" style="color: {{dataRow.haloColor}};" class="halo__image">
                                                    <flux-halo-icon name="{{ dataRow.imageSource }}"></flux-halo-icon>
                                                </div>

                                                <flux-avatar
                                                    ng-if="dataRow.imageUrl"
                                                    name="{{dataRow.key}}"
                                                    image-url="{{ dataRow.imageUrl }}"
                                                    initials-count="1"
                                                    class="avatar__image"
                                                    rounded
                                                ></flux-avatar>
                                            </div>

                                            <div class="af__table__title">
                                                <md-tooltip>{{ dataRow.key }}</md-tooltip>
                                                <span class="user__link"><a href="{{dataRow.profileUrl}}" target="_blank">{{ dataRow.key }}
                                                    <mw-icon svg-icon="action:ic_launch_24px" aria-label="Open in new tab" class="user__link__icon"></mw-icon></a>
                                                </span>
                                            </div>
                                        </td>
                                        <td ng-if="dataRow.value" class="af__table__numbers"> {{dataRow.value | mwTruncateNumber}} </td>
                                        <td ng-if="dataRow.followers" class="af__table__numbers"> {{dataRow.followers | mwUsNumberSystem}} </td>
                                        <td ng-if="dataRow.subscriber" class="af__table__numbers"> {{dataRow.subscriber | mwTruncateNumber}} </td>
                                        <td ng-if="dataRow.mention" class="af__table__numbers"> {{dataRow.mention | mwTruncateNumber}} </td>
                                    <tr>
                                <tbody>
                            </table>
                        </md-table-container>
                </mw-table>

            </div>
        `,
  bindings: BaseVisualization.config.bindings,
 }

 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Authors', 'Tweets', 'Followers', 'Image Link']
 public transformationProfiles: CSVTranformationProfile[] = []

 $onInit() {}

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (this.hasChanges(changes.vizData)) {
   if (changes.vizData.currentValue.data) {
    //reset pagination when data is changed/updated
    this.pagination.currentPage = 0

    this.updateData(changes.vizData.currentValue.data)
    this.updateOptions()
    this.buildCSVExportProfile()
   } else {
    this.visualizationData = {}
    this.pagination.currentPage = 0
    this.pagination.pageSize = 0
    this.pagination.contentLength = 0
    this.pagination.itemIndex = 0
   }
  }

  // watch for pagination changes
  if (this.hasChanges(changes.pagination)) {
   this.updateData(this.vizData.data)
   this.updateOptions()
  }
 }

 updateData(data) {
  if (data) {
   this.pagination.pageSize = 7;
   // update data length for pagination
   this.pagination.contentLength = data.all.length
   this.pagination.itemIndex = this.pagination.currentPage * this.pagination.pageSize === 0 ? 1 : this.pagination.currentPage * this.pagination.pageSize + 1;
   this.visualizationData = this.isObjEmpty(data) ? data : this.buildTableDataChartData(data.all)
  }
 }

 updateOptions() {
  this.visualizationOptions = this.buildTableDataOptions()
 }

 buildTableDataChartData(data) {
  // calculate indexes for pagination
  let startIndex = this.pagination.currentPage * this.pagination.pageSize
  let endIndex = this.pagination.currentPage * this.pagination.pageSize + this.pagination.pageSize
  return data.slice(startIndex, endIndex).map(x => ({ ...x, key: '@' + x.key }))
 }

 buildTableDataOptions() {
  return ['icm-web__contact-profile--activity-table-column-author', 'explore__title--tweets', 'explore__title--followers']
 }

 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}